import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AgeClass } from '@tanzspass/shared';
import { AgeClassService } from '../../services/age-class.service';

@Component({
  selector: 'ts-event-sidenav-menu',
  templateUrl: './event-sidenav-menu.component.html',
  styleUrls: ['./event-sidenav-menu.component.css'],
  imports: [RouterLink, MatIcon],
  host: { ngSkipHydration: 'true' },
})
export class EventSidenavMenuComponent implements OnInit {
  public ageClasses: AgeClass[];

  constructor(private ageClassSrv: AgeClassService) {}

  ngOnInit() {
    this.ageClassSrv.frontPage().subscribe((ageClasses) => {
      this.ageClasses = ageClasses;
    });
  }
}
